<template>
    <div class="wrapper">
        <aside>
            <div class="fixed">
                <img class="foreground" src="@/assets/img/img_country.jpg">
            </div>
        </aside>
        <div class="main">
            <div class="d-flex mt-auto my-3 h-100">
                <div class="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
                    <main class="px-3">
                        <div class="row mb-4">
                            <div class="col">
                                <h1 class="">Select country</h1>
                            </div>
                            <!-- <div class="col text-end px-3 pt-3">
                                <a class="logout" @click="$logout()"> Logout </a>
                            </div> -->
                        </div>
                        <div class="grid text-center countries-test">
                            <a v-for="country in $config.countries.sort()" :key="country" :href="'/' + country"
                                :class="{disabled: !available(country)}" class="g-col-6 px-5 pt-4">
                                <div>
                                    <icon :name="'icon-' + country" :width="'100%'" :height="'100%'" />
                                </div>
                                <p> {{ $t(country) }} </p>
                            </a>
                        </div>
                    </main>
                </div>
            </div>

            <footer class="footer mt-auto">
                <div class="fixed">
                    <span class="text-muted">Powered by <a href="//www.masae-analytics.com/" target="_blank">Masae
                            Analytics</a></span>
                </div>
            </footer>

        </div>
    </div>
</template>

<script>
export default {
    name: 'countries',
    mounted() {
        this.$modal.show('data-modal');
    },
    methods: {
        available(code) {
            // TODO: verify available countries
            const availableCountries = ["co", "et", "ke"];
            return availableCountries.includes(code);
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/style/scss/components/countries';
</style>
